<template>
  <section class="section integration">
    <div class="section__container integration__container">
      <h2 class="section__title integration__title"
          id="integration">Интеграции</h2>
      <div id="tabs" class="integration__slider">
        <v-app>
          <v-tabs
            v-model="tabs"
            background-color="transparent"
            color="#6BB022"
          >
            <v-tab>Популярные CMS</v-tab>
            <v-tab>Банки и платежные системы</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-card-text class="tabs__item tabs__item_frst">
                  <template>
                  <v-carousel height="auto"
                              width="100%"
                              class="tabs__slider-list">
                    <v-carousel-item class="tabs__slider-item">
                      <a href="https://ofd.ru/razrabotchikam/cms-bitrix" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/bitrix.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-cs-cart" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/cs_cart.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-shopscript" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/shop_script.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-umi" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/umi.png" class="cms__item-image"/>
                      </a>
                    </v-carousel-item>
                    <v-carousel-item class="tabs__slider-item">
                      <a href="https://ofd.ru/razrabotchikam/cms-drupal7-commerce-ubercart" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/drupal7.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-drupal8-commerce-ubercart" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/drupal8.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-wordpress" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/wordpress.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-joomla-virtuemart" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/virtue_mart.png" class="cms__item-image"/>
                      </a>
                    </v-carousel-item>
                    <v-carousel-item class="tabs__slider-item">
                      <a href="https://ofd.ru/razrabotchikam/cms-drupal7-commerce-ubercart" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/ubercart7.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-drupal8-commerce-ubercart" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/ubercart8.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-netcat" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/netcat.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-diafan" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/diafan.png" class="cms__item-image"/>
                      </a>
                    </v-carousel-item>
                    <v-carousel-item class="tabs__slider-item">
                      <a href="https://ofd.ru/razrabotchikam/cms-phpshop" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/phpshop.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-vamshop" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/vam.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-opencart" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/opencart.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-magento" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/magento.png" class="cms__item-image"/>
                      </a>
                    </v-carousel-item>
                    <v-carousel-item class="tabs__slider-item">
                      <a href="https://ofd.ru/razrabotchikam/cms-hostcms" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/hotcms.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-prestashop" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/presta.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-joomla-jshopping" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/joom.png" class="cms__item-image"/>
                      </a>
                      <a href="https://ofd.ru/razrabotchikam/cms-modxrevo-minishop2" target="_blank" class="tabs__slider-link">
                        <img src="./assets/cms/modx.png" class="cms__item-image"/>
                      </a>
                    </v-carousel-item>
                  </v-carousel>
                  </template>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text class="tabs__item tabs__item_frst">
                  <template>
                  <v-carousel height="auto"
                              class="tabs__slider-list">
                    <v-carousel-item class="tabs__slider-item">
                      <a href="https://ofd.ru/baza-znaniy/voprosy-po-uslugam/integraciya-ferma-s-platyozhnymi-sistemami/integraciya-onlayn-kassy" target="_blank"
                         class="tabs__slider-link">
                        <img src="./assets/banks/sber.png" class="payments__item-image"/>
                      </a>
                      <a href="https://ofd.ru/baza-znaniy/voprosy-po-uslugam/integraciya-ferma-s-platyozhnymi-sistemami/nastroyka-integracii-mkb" target="_blank"
                         class="tabs__slider-link">
                        <img src="./assets/banks/mkb.png" class="payments__item-image"/>
                      </a>
                      <a href="https://ofd.ru/baza-znaniy/voprosy-po-uslugam/integraciya-ferma-s-platyozhnymi-sistemami/integraciya-alfabank" target="_blank"
                         class="tabs__slider-link">
                        <img src="./assets/banks/alfa.png" class="payments__item-image"/>
                      </a>
                      <a href="https://ofd.ru/baza-znaniy/voprosy-po-uslugam/integraciya-ferma-s-platyozhnymi-sistemami/instrukciya-po-integracii" target="_blank"
                         class="tabs__slider-link">
                        <img src="./assets/banks/modulbank.png" class="payments__item-image"/>
                      </a>
                    </v-carousel-item>
                    <v-carousel-item class="tabs__slider-item">
                      <a href="https://ofd.ru/baza-znaniy/voprosy-po-uslugam/integraciya-ferma-s-platyozhnymi-sistemami/nastroyka-integracii-0" target="_blank"
                         class="tabs__slider-link">
                        <img src="./assets/banks/inplat.png" class="payments__item-image"/>
                      </a>
                      <a href="https://ofd.ru/baza-znaniy/voprosy-po-uslugam/integraciya-ferma-s-platyozhnymi-sistemami/nastroyka-integracii-1" target="_blank"
                         class="tabs__slider-link">
                        <img src="./assets/banks/payanyway.png" class="payments__item-image"/>
                      </a>
                      <a href="https://ofd.ru/baza-znaniy/voprosy-po-uslugam/integraciya-ferma-s-platyozhnymi-sistemami/nastroyka-integracii" target="_blank"
                         class="tabs__slider-link">
                        <img src="./assets/banks/payumoney.png" class="payments__item-image"/>
                      </a>
                      <a href="https://ofd.ru/baza-znaniy/voprosy-po-uslugam/integraciya-ferma-s-platyozhnymi-sistemami/nastroyka-integracii-paypal" target="_blank"
                         class="tabs__slider-link">
                        <img src="./assets/banks/paypal.png" class="payments__item-image"/>
                      </a>
                    </v-carousel-item>
                    <v-carousel-item class="tabs__slider-item">
                      <a href="https://ofd.ru/baza-znaniy/voprosy-po-uslugam/integraciya-ferma-s-platyozhnymi-sistemami/nastroyka-integracii-forabank" target="_blank"
                         class="tabs__slider-link">
                        <img src="./assets/banks/forabank.png" class="payments__item-image"/>
                      </a>
                      <a href="https://ofd.ru/baza-znaniy/voprosy-po-uslugam/integraciya-ferma-s-platyozhnymi-sistemami/nastroyka-integracii-chronopay" target="_blank"
                         class="tabs__slider-link">
                        <img src="./assets/banks/chronopay.png" class="payments__item-image"/>
                      </a>
                      <a href="https://ofd.ru/baza-znaniy/voprosy-po-uslugam/integraciya-ferma-s-platyozhnymi-sistemami/nastroyka-integracii-cloudpayment" target="_blank"
                         class="tabs__slider-link">
                        <img src="./assets/banks/cluudpayments.png" class="payments__item-image"/>
                      </a>
                      <a class="tabs__slider-link"></a>
                    </v-carousel-item>
                  </v-carousel>
                  </template>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-app>
      </div>
      <p class="integration__text">
        Для компаний, которые <span class="integration__text-underlined">уже произвели интеграцию</span> со
        сторонними сервисами по аренде облачных касс, переход на Ferma <span>НЕ ПОТРЕБУЕТ ДОПОЛНИТЕЛЬНОЙ РАЗРАБОТКИ</span>.
        Вам нужно всего лишь изменить адрес запроса на формирование чека, логин и пароль клиента. Повторная
        интеграция не требуется.
      </p>
      <div class="integration__action">
        <a class="button" v-scrollTo="'calc'">
          Подключить Ferma
          <img src="../../assets/images/chevron.svg" alt="">
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Integration',
  data() {
    return {
      tabs: null,
    }
  },
}
</script>

<style src="./component.scss" scoped lang="scss"/>
